module.exports = __webpack_public_path__ + "img/600_SERF_2022_Correct.4d13987e.png";